module.exports = __webpack_public_path__ + "static/media/logo_stockapp.32cc4454.webp";